import {atomWithReset} from 'jotai/utils'

export const gameCodeState = atomWithReset<number | null>(null)
